import React from "react";
import { safeShippingUrl } from "../lib/shippingLinks";

export default function ShipmentTracking({ shipping }) {
  if (!shipping) return null;
  const packages = shipping.packages?.length ? shipping.packages : [shipping];
  const shipped = shipping.status === "shipped";
  return (
    <section className="mt-5 border-l-2 border-[#26C6D5] pl-4" aria-label="Shipment tracking">
      <h2 className="text-lg font-semibold text-stone-100">Shipping update</h2>
      {!shipped ? <p className="mt-2 text-sm text-stone-300">Your order is being prepared. Tracking will appear once your parcels are handed to the carrier.</p> : (
        <ul className="mt-2 space-y-2 text-sm text-stone-300">
          {packages.filter((parcel) => parcel.tracking_number).map((parcel, index) => (
            <li key={`${parcel.parcel_index ?? index}-${parcel.tracking_number}`}>
              <p>Parcel {(parcel.parcel_index ?? index) + 1}: <span className="select-all">{parcel.tracking_number}</span></p>
              {safeShippingUrl(parcel.tracking_url) && <a href={safeShippingUrl(parcel.tracking_url)} target="_blank" rel="noopener noreferrer" className="underline text-[#26C6D5]">Track parcel {(parcel.parcel_index ?? index) + 1}</a>}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
